import { Box, Button, Center, Text, useDisclosure } from "@chakra-ui/react";
import { useDeleteAccountMutation } from "apis";
import { CloseNewSVG, DeleteAcctSVG, TrashSVG } from "assets";
import { AbstractModal, IconMenuItem, Input, InputLabel } from "components";
import { useState } from "react";
import { clearSession } from "utils";
import ls from "utils/secureStorage";

const DeleteAccount = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const [_deleteAcct, { isLoading }] = useDeleteAccountMutation();
  const deleteAccount = async () => {
    const response: any = await _deleteAcct({});

    if (response.data) {
      onClose();
      clearSession();
    }
  };

  const email = ls.get("email");
  const [checkEmail, setCheckEmail] = useState("");
  return (
    <>
      <IconMenuItem svg={<DeleteAcctSVG />} title="Delete Account" onClick={onOpen} textColor="red.500" fw="500" />

      <AbstractModal
        isOpen={isOpen}
        onClose={onClose}
        isCentered={false}
        _content={{
          // maxW: "434px",
          maxW: "334px",
          // height: "441px",
          borderRadius: "20px",
          p: "78px 14px 45px",
        }}
      >
        <Box
          pos="absolute"
          top={{ base: "3%", md: "3%" }}
          right={{ base: "6%", md: "5%" }}
          onClick={onClose}
          cursor="pointer"
          _hover={{
            zoom: "1.05",
            transition: "all .5s ease-in",
          }}
        >
          <CloseNewSVG />
        </Box>

        <Center flexDir="column">
          <TrashSVG />
          <Text margin={{ base: "12px 0 29px" }} fontWeight="700" fontFamily="var(--bitmama-fonts-heading)">
            Delete Account
          </Text>
          {/* <Text maxWidth="186px" mx="auto" textAlign="center">
            Are you sure you want to Delete your Account?
          </Text> */}
          <Box px="4px" width="100%" mt="8px">
            <InputLabel textAlign="center" display="block" fontSize="14px" htmlFor="email">
              To confirm, type your email in the input below
            </InputLabel>
            <Input id="email" width="100%" onChange={(e) => setCheckEmail(e.target.value)} />
          </Box>

          <Button
            margin={{ base: "48px 0 30px" }}
            minW="100%"
            onClick={deleteAccount}
            isLoading={isLoading}
            isDisabled={isLoading || email !== checkEmail}
            _hover={{
              _disabled: {
                opacity: 0.3,
              },
            }}
          >
            {/* Yes, &nbsp;delete */}
            Delete
          </Button>
          <Text cursor="pointer" textDecor="underline" fontWeight="500" onClick={onClose} color="#0D4740">
            Cancel
          </Text>
        </Center>
      </AbstractModal>
    </>
  );
};

export default DeleteAccount;
